import { render, staticRenderFns } from "./aiShareCard1.vue?vue&type=template&id=2c503b96&scoped=true"
import script from "./aiShareCard1.vue?vue&type=script&lang=js"
export * from "./aiShareCard1.vue?vue&type=script&lang=js"
import style0 from "./aiShareCard1.vue?vue&type=style&index=0&id=2c503b96&prod&lang=scss&scoped=true"
import style1 from "./aiShareCard1.vue?vue&type=style&index=1&id=2c503b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c503b96",
  null
  
)

export default component.exports